module.exports = __webpack_public_path__ + "img/meu-negocio.20455c6a.svg";